export default __webpack_public_path__ + "static/media/cph-high.8c0736d5.png";